/* eslint-disable */
import Vue from 'vue'
import Lodash from 'lodash';

Vue.prototype.$_ = Lodash;